import { markdownAstFromDom } from './markdownAstFromDom';
import { markdownAstToString } from './markdownAstToString';

/** Produces Markdown from the div/line-based content of a `contenteditable` editor. */
export function markdownFromDom(container: Node) {
  const markdownAst = markdownAstFromDom(container);
  return markdownAstToString(markdownAst);
}
